import { Children } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
function Column({
  align,
  children,
  justify
}) {
  return /*#__PURE__*/_jsx(UIFlex, {
    direction: "column",
    align: align,
    justify: justify,
    children: Children.map(children, child => /*#__PURE__*/_jsx("div", {
      children: child
    }))
  });
}
Column.defaultProps = {
  align: 'start',
  justify: 'start'
};
export default Column;